export default function Footer() {
  return (
    <footer className="py-6 bg-gray-900 text-center text-gray-400">
      <p className="text-sm">
        Made by <span className="text-amber-400 font-semibold">Tanusree Roy</span> with <span className="text-red-400">♥</span>
      </p>
    </footer>
  );
}
